import React, {useEffect, useState, useCallback} from "react";
import Required from "../../../../components/Required";
import Checkbox from "../../../../components/Checkbox";
import { DisabledCheckbox } from '../7042/components'
import {FacilityItem} from '../../sections/AuthorizationToReleaseSection'
import './FacilitiesSection.scss'

const GuthrieFacilitySection = ({ formik, inputClasses, props, template, config }) => {
    
  const [guthrieMedicalGroupInput, setGuthrieMedicalGroupInput] = useState(null)
  const [guthrieMedicalGroupCheck, setGuthrieMedicalGroupCheck] = useState(false)
  const [guthrieMedicalGroupValue, setGuthrieMedicalGroupValue] = useState(null)
  
    useEffect(()=>{
      const newFacilities = formik.values.facilitiesGroup.filter(fac => !fac.includes('Guthrie Medical Group'))
      console.log(newFacilities);
      if(guthrieMedicalGroupInput && guthrieMedicalGroupCheck){
        formik.setFieldValue('facilitiesGroup', [...newFacilities, `Guthrie Medical Group: ${guthrieMedicalGroupInput}`])
      } else{
        formik.setFieldValue('facilitiesGroup', formik.values.facilitiesGroup.filter(fac => !fac.includes('Guthrie Medical Group')))
      }
    }, [guthrieMedicalGroupInput, guthrieMedicalGroupCheck])
    
    useEffect(()=>{
      !guthrieMedicalGroupValue && formik.setFieldValue('otherFac', '')
    }, [formik.values.otherFac])
    
    useEffect(()=>{
      !guthrieMedicalGroupCheck && formik.setFieldValue('otherFac', '') && setGuthrieMedicalGroupValue('')
      if (!guthrieMedicalGroupCheck) {
        document.getElementById('GMGCField').value = ''
      }
    }, [guthrieMedicalGroupCheck])
    
    
    return (
        config.page.form.sections.authorizationToReleaseSection.active ?
          <div id='medicalFacilitiesRequested' className='form-section thr-form-section'>
            <h2 style={template.styles.section} className="section-heading"> {template.title} </h2>
            <label className='non-textbox-label'> <span style={template.styles.label}> {'I authorize'} </span> {" "} <Required value={template.fields.facilitiesGroup.validations.required.value} /> </label>
            <div className="hospitalFacilities">
              <strong>Hospital:</strong>
              <Checkbox style={template.styles.list} className="custom-form-check checkbox" key={'Facility1'} name="facilitiesGroup" label={'Corning'} value={'Facility1'} />
              <Checkbox style={template.styles.list} className="custom-form-check checkbox" key={'Facility2'} name="facilitiesGroup" label={'Cortland'} value={'Facility2'} />
              <Checkbox style={template.styles.list} className="custom-form-check checkbox" key={'Facility3'} name="facilitiesGroup" label={'Robert Packer'} value={'Facility3'} />
              <Checkbox style={template.styles.list} className="custom-form-check checkbox" key={'Facility4'} name="facilitiesGroup" label={'Robert Packer Hospital Towanda Campus'} value={'Facility4'} />
              <Checkbox style={template.styles.list} className="custom-form-check checkbox" key={'Facility5'} name="facilitiesGroup" label={'Troy'} value={'Facility5'} />
              <Checkbox style={template.styles.list} className="custom-form-check checkbox" key={'Facility6'} name="facilitiesGroup" label={'Lourdes Hospital'} value={'Facility6'} />
            </div>
            <div className="gmg">
              <strong>Clinic Location:</strong>
              {/* <Checkbox style={template.styles.list} className="custom-form-check checkbox" key={'Facility1'} name="facilitiesGroup" label={`Guthrie Medical Group:`}  /> */}
              <input type="checkbox" style={{width:18, height: 18, marginRight: 10}} onChange={(e)=>{setGuthrieMedicalGroupCheck(e.target.checked)}}/>
              Guthrie Medical Group:
              <input type="text" id='GMGCField' disabled={!guthrieMedicalGroupCheck} placeholder='City, State (indicate all locations)' className='form-control'  onChange={(e)=>{formik.setFieldValue('otherFac', e.target.value); setGuthrieMedicalGroupValue(e.target.value)}}/>
              {/* <FacilityItem item={{key: 'otherFac', value: 'City, State (indicate all locations)'}} template={template} formik={formik} config={config} disabled={false} key={54321}/> */}
            </div>
            <br />
            {/* <FacilityItem item={{key: 'otherFac', value: 'Specific facility or provider at CBC Trial Works'}} template={template} formik={formik} config={config} disabled={false} key={54321}/> */}
          </div>
          :
          <></>
      );
};

export default GuthrieFacilitySection;

